<main class="kebab-list-container">
  <section class="kebab-list-item" (click)="addToWatchlist(data)">
    <span class="icon-text">
      <lucide-icon name="bookmark" class="watchlist" size="14"></lucide-icon>
      <span>WatchList</span>
    </span>
  </section>
</main>
